$('body a.minicart-link').mouseenter(function(){
    $(document).ajaxStop(function(){
        setTimeout(function(){ 
            //console.log('trigger mini cart script : ',deleteConfirmationButton);
            var deleteConfirmationButton = $('#removeProductModal button.cart-delete-confirmation-btn');
            deleteConfirmationButton.on('click', function() {            
                var checkingPlanInCart = setInterval(function() {
                    //global function located in planChecker.js
                    // eslint-disable-next-line no-undef
                    checkIfPlanInCart();
                    if ($('#next_protection_Plan_Panel').height() < 0 || $('#maf_renewalPlan_addToCart').height() < 0 || $('#maf_renewalPlan_addToCart').height() > 0){
                        clearInterval(checkingPlanInCart);
                    }
                }, 1000);                 
            });
        }, 800);
    });
});
